import { render, staticRenderFns } from "./NavBarMenu.vue?vue&type=template&id=47dc60aa"
import script from "./NavBarMenu.vue?vue&type=script&lang=js"
export * from "./NavBarMenu.vue?vue&type=script&lang=js"
import style0 from "./NavBarMenu.vue?vue&type=style&index=0&id=47dc60aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports